import { render } from "./Index.vue?vue&type=template&id=0c9a36af&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0c9a36af&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c9a36af"

export default script